import { SearchTwoTone as SearchTwoToneIcon } from '@mui/icons-material'
import { Button, Stack, TextField } from '@mui/material'
import { useState } from 'react'

interface Props {
  setSearchText: (value: string) => void
}

export function Search(props: Props) {
  const { setSearchText } = props
  const [value, setValue] = useState('')

  const handleSubmit = (e: React.SubmitEvent<HTMLFormElement>) => {
    e.preventDefault()
    setSearchText(value.trim())
  }

  return (
    <Stack component="form" direction="row" onSubmit={handleSubmit}>
      <TextField
        placeholder="Search"
        helperText="Search by Media Number, Title, Provider Name, or Provider CWS ID"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        slotProps={{
          input: {
            sx: {
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
            },
          },
          formHelperText: {
            sx: {
              color: 'primary',
              marginLeft: 0,
            },
          },
        }}
      />
      <Button
        name="search"
        variant="contained"
        size="large"
        type="submit"
        sx={{
          height: 56,
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
        }}
      >
        {<SearchTwoToneIcon />}
      </Button>
    </Stack>
  )
}
